/**
 * How many bytes are there in data size notations such as
 * `'10MB'` or `'5kb'` or `1024`
 * @param dataSize
 */
export function dataSizeUnitToBytes(dataSize: string | number): number {
  if (dataSize == undefined) {
    return 0;
  }
  if (typeof dataSize === 'number') {
    return dataSize;
  }

  const k = 1024;
  const units = ['b', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];

  // Remove everything after the number
  const base = parseInt(dataSize);

  // Remove the number from the string
  const unit = dataSize.replace(String(base), '').trim().toLowerCase();

  const power = units.findIndex((_) => _ === unit);

  if (power > -1) {
    return base * k ** power;
  } else {
    return base;
  }
}
